export default __webpack_public_path__ + "static/assets/1c40439ee734cfa0d188c53bb9337205.svg";